let state = {
  unpaidTxnCount: undefined,
  outstandingAmount: undefined,
  availableCreditLimit: undefined,
  dueTxnCount: undefined,
  overdueTxnCount: undefined,
  daysToFreeze: undefined,
  creditPaused: undefined,
  creditPauseMsg: undefined,
  foodForThought: undefined,
  unsettledTransactionList: [],
  alertMessage:undefined,
  loaderInterval: undefined
}
export default state



// WEBPACK FOOTER //
// ./src/store/home/state.js